import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useVehicleTypeSubmit from "hooks/useVehicleTypeSubmit";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const VehicleTypeDrawer = ({ id }) => {
  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,
  
  } = useVehicleTypeSubmit(id);
  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Vehicle Type"} description={""} />
        ) : (
          <Title title={"Add Vehicle Type"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <div className="col-span-12">
                <LabelArea required label={"Vehicle Type"} />
                <InputArea
                  register={register}
                  label="Vehicle Type"
                  name="name"
                  type="text"
                  placeholder={"Vehicle Type"}
                  maxLength={120}
                  // pattern={/^[A-Za-z\s]+$/}
                />
                <Error errorName={errors.name} />
              </div>
            </div>
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default VehicleTypeDrawer;
